

import React from 'react';

import bannerImage1 from '../../Assets/Work/1.jpg'; 

import bannerImage2 from '../../Assets/Work/2.jpg'; 

import bannerImage3 from '../../Assets/Work/3.jpg'; 
const BannerSection = () => {
  return (
    <section className="py-5  mg-0" style={{background:"linear-gradient(45deg,rgb(235 248 255),rgb(196 229 249))"}}>
      <div className="container">
        {/* Title */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h2 className="fw-bold" style={{color:"#333333",fontSize:"32px"}}>Innovative Technologies for Human Performance and Rehabilitation</h2>
          </div>
        </div>

        {/* Cards */}
        <div className="row g-4">

          {/* Card 1 */}
          <div className="col-12 col-md-4">
            <div className="card border-0 shadow h-100">
              <img
                src={bannerImage1}
                alt="Card 1"
                className="card-img-top img-fluid"
                loading="lazy"
              />
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-12 col-md-4">
            <div className="card border-0 shadow h-100">
              <img
                src={bannerImage2}
                alt="Card 2"
                className="card-img-top img-fluid"
                loading="lazy"
              />
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-12 col-md-4">
            <div className="card border-0 shadow h-100">
              <img
                src={bannerImage3}
                alt="Card 3"
                className="card-img-top img-fluid"
                loading="lazy"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default BannerSection;
